import * as Yup from "yup";

export const userValidationSchema = Yup.object({
  profilePicture: Yup.mixed().required(
    "Profile picture is required"
  ),

  name: Yup.string()
    .matches(
      /^[A-Za-z\s]+$/,
      "Only letters are allowed"
    )
    .required("User name is required"),

  email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),

  phone: Yup.string()
    .matches(
      /^[0-9]{10,15}$/,
      "Invalid phone number"
    )
    .required("Phone number is required"),

  country: Yup.string().required(
    "Country is required"
  ),

  designation: Yup.string().required(
    "Designation is required"
  ),
});